import hotToast from "react-hot-toast";
import { errorMessage, isTransientError } from "../api/messages";
import { i18n } from "../i18n";
import { undoToast } from "./toast-undo";

/**
 * One place decides how an action's outcome is announced. Callers pass the
 * raw error — never a pre-formatted string — so the copy in `messages.ts`
 * (with its 503-is-not-your-fault guidance) is what people read.
 */
export const toast = {
	success: (message: string) => hotToast.success(message),
	error: (err: unknown, prefix?: string) => {
		const text = errorMessage(err);
		// The "{{prefix}}: {{text}}" joiner is a key, so a locale whose
		// punctuation differs can reorder or restyle it.
		return hotToast.error(prefix ? i18n.t("nav:toast.prefixed", { prefix, text }) : text, {
			// Connection problems deserve a longer read — the fix is "wait", not "retry now".
			duration: isTransientError(err) ? 7000 : 5000,
		});
	},
	info: (message: string) => hotToast(message),
	/** A page-only change with an Undo button (`toast-undo.tsx`). */
	undoable: undoToast,
	dismiss: (id: string) => hotToast.dismiss(id),
};
